import { Visibility, VisibilityOff } from "@mui/icons-material";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { useState } from "react";
import axiosInstance from "../../../../../axiosInstance";

const ChangePasswordModal = (props) => {
  const [Password, setPassword] = useState("");
  const [ShowPassword, setShowPassword] = useState(false);
  const [NewPassword, setNewPassword] = useState("");
  const [ShowNewPassword, setShowNewPassword] = useState(false);
  const [ChangesMade, setChangesMade] = useState(false);
  const [PassError, setPassError] = useState("");
  const [NewPassError, setNewPassError] = useState("");

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setChangesMade(true);
    setPassError("");
  };

  const handleShowPassword = () => {
    setShowPassword(!ShowPassword);
  };

  const handleNewPasswordChange = (event) => {
    setNewPassword(event.target.value);
    setChangesMade(true);
    entriesNewNewPasswordPassValidation(event.target.value);
  };

  const handleShowNewPassword = () => {
    setShowNewPassword(!ShowNewPassword);
  };

  const entriesNewNewPasswordPassValidation = (NewPassword) => {
    if (
      NewPassword.trim() &&
      NewPassword.length >= 8 &&
      /[A-Z]/.test(NewPassword) &&
      /\d/.test(NewPassword) &&
      /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(NewPassword)
    ) {
      setNewPassError("");
    } else {
      setNewPassError(
        "8 characters, 1 capital latter, 1 digit, 1 special character"
      );
    }
  };

  const updateUserPassword = () => {
    let Req = {
      method: "POST",
      baseURL:
        window.localStorage.getItem("BaseURL") + "/api/account/change-password",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        currentPassword: Password,
        newPassword: NewPassword,
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        props.Close();
      })
      .catch((Err) => {
        console.log(Err);
        if (
          Err.response.status === 400 &&
          Err.response.data.detail === "Incorrect password"
        ) {
          setPassError("Wrong password");
        }
      });
  };

  return (
    <div className="password-change-modal">
      <p className="modal-title">Change your password</p>
      <TextField
        fullWidth
        name="current-password"
        id="current-password"
        label={"Current password"}
        placeholder={""}
        type={ShowPassword ? "text" : "password"}
        variant="outlined"
        value={Password}
        onChange={handlePasswordChange}
        margin="normal"
        error={Boolean(PassError)} // Show error state based on whether there is an error message
        helperText={PassError} // Display error message below the field
        sx={{
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              borderColor: "#79747E", // Change border color when focused
            },
          backgroundColor: "transparent",
          borderRadius: "8px",
          borderBottom: "none",
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleShowPassword}
                edge="end"
                style={{ color: "#FB4764" }}
              >
                {ShowPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <TextField
        fullWidth
        name="new-password"
        id="new-password"
        label={"New password"}
        placeholder={""}
        type={ShowNewPassword ? "text" : "password"}
        variant="outlined"
        value={NewPassword}
        onChange={handleNewPasswordChange}
        margin="normal"
        error={Boolean(NewPassError)} // Show error state based on whether there is an error message
        helperText={NewPassError} // Display error message below the field
        sx={{
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              borderColor: "#79747E", // Change border color when focused
            },
          backgroundColor: "transparent",
          borderRadius: "8px",
          borderBottom: "none",
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleShowNewPassword}
                edge="end"
                style={{ color: "#FB4764" }}
              >
                {ShowNewPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <section className="modal-actions">
        <span onClick={() => props.Close()}>Cancel</span>
        <span
          onClick={() => updateUserPassword()}
          className={
            Password.length >= 8 &&
            NewPassword.length >= 8 &&
            Password !== NewPassword
              ? ""
              : "disabled"
          }
        >
          Save
        </span>
      </section>
    </div>
  );
};

export default ChangePasswordModal;
